<div class="flex h-full items-center justify-between">
  @if (!params?.isIconHidden && !!params?.value) {
    <aux-icon [name]="icon" class="min-w-[24px]" [ngClass]="iconColorClass" />
  }

  <div
    #text
    [auxTooltip]="text.offsetWidth < text.scrollWidth ? params?.valueFormatted || '' : ''"
    class="grow truncate"
    [ngClass]="textColorClass"
  >
    {{ params?.valueFormatted }}
  </div>
</div>
